import * as React from 'react';
import CreditsFilterBar from './CreditsFilterBar';
import CreditsTableDesktop from './CreditsTableDesktop';
import CreditsTableMobile from './CreditsTableMobile';
import TablePaginator from 'src/components/common/TablePagination';

import CreditModel from 'src/model/credit.model';

import './ManageCredits.scss';
import Loader from 'src/components/common/Loader';

interface IManageCreditsProps {
  payments: CreditModel[];
  statusFilter: 'PENDING' | 'VOID' | 'DISPOSED';
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
  isPending: number;
  selectedCredit: CreditModel;
  handleCreditDetails: (credit: CreditModel) => void;
  getCredits: (
    page: number,
    status: 'PENDING' | 'VOID' | 'DISPOSED',
    sortby: string
  ) => void;
}
interface ICreditsTableDesktopState {
  desc: string;
  asc: string;
  sortColname: string;
  sortByStr: string;
}
class ManageCredits extends React.Component<
  IManageCreditsProps,
  ICreditsTableDesktopState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      desc: 'active',
      asc: '',
      sortColname: 'pmtDate',
      sortByStr: 'pmtDate,desc'
    };
  }

  public componentDidMount() {
    this.getCreditsByPage(0);
  }

  private getCreditsByPage = (page: number) => {
    this.props.getCredits(page, this.props.statusFilter, this.state.sortByStr);
  };

  private handlePagination = (type: 'next' | 'previous') => {
    const { pageNumber, totalPages } = this.props;

    if (type === 'previous') {
      if (pageNumber !== 0) {
        this.getCreditsByPage(pageNumber - 1);
      }
    } else {
      if (pageNumber !== totalPages) {
        this.getCreditsByPage(pageNumber + 1);
      }
    }
  };

  private handleSortedVal = (colname: any) => {
    let sortBy = '';
    if (colname === this.state.sortColname) {
      if (this.state.desc === 'active') {
        sortBy = colname + ',asc';
        this.setState({ desc: '', asc: 'active', sortByStr: sortBy });
      } else {
        sortBy = colname + ',desc';
        this.setState({ desc: 'active', asc: '', sortByStr: sortBy });
      }
    } else {
      sortBy = colname + ',desc';
      this.setState({
        sortColname: colname,
        desc: 'active',
        asc: '',
        sortByStr: sortBy
      });
    }
    this.props.getCredits(0, this.props.statusFilter, sortBy);
  };

  public render() {
    return (
      <div className="rp-manage-credits container-fluid">
        <CreditsFilterBar sortby={this.state.sortByStr} />
        {this.props.isPending ? (
          <Loader />
        ) : (
          <React.Fragment>
            <div className="rp-manage-credits-desktop">
              <CreditsTableDesktop
                credits={this.props.payments}
                handleSortedVal={this.handleSortedVal}
                desc={this.state.desc}
                asc={this.state.asc}
                sortColname={this.state.sortColname}
              />
            </div>
            <div className="rp-manage-credits-mobile">
              <CreditsTableMobile
                credits={this.props.payments}
                selectedCredit={this.props.selectedCredit}
                handleCreditDetails={this.props.handleCreditDetails}
              />
            </div>
            <TablePaginator
              handlePagination={this.handlePagination}
              pagination={{
                pageNumber: this.props.pageNumber,
                pageSize: this.props.pageSize,
                totalPages: this.props.totalPages
              }}
            />
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default ManageCredits;
